import {
  getGoogleClientId,
  isApiConfigured,
  isApiUseRelative,
  isProductionBuild,
} from '@/config/env'
import { APP_LOG_PREFIX } from '@/helpers/constants'

/**
 * Fail fast in production builds when required configuration is missing.
 * Logs errors to console; does not throw (allows error boundary to surface misconfig).
 */
export function validateProductionEnv() {
  if (!isProductionBuild()) return

  const errors = []

  if (!isApiConfigured()) {
    errors.push('Set VITE_API_BASE_URL or VITE_API_USE_RELATIVE=true for production.')
  }

  if (import.meta.env.VITE_BRIEFING_USE_MOCK === 'true') {
    errors.push('VITE_BRIEFING_USE_MOCK must not be true in production.')
  }
  if (import.meta.env.VITE_INBOX_USE_MOCK === 'true') {
    errors.push('VITE_INBOX_USE_MOCK must not be true in production.')
  }
  if (import.meta.env.VITE_NOTES_USE_MOCK === 'true') {
    errors.push('VITE_NOTES_USE_MOCK must not be true in production.')
  }
  if (import.meta.env.VITE_AUTH_DEV_BYPASS === 'true') {
    errors.push('VITE_AUTH_DEV_BYPASS must not be true in production.')
  }

  if (!getGoogleClientId()) {
    errors.push('Google sign-in requires VITE_GOOGLE_CLIENT_ID.')
  }

  if (errors.length > 0) {
    console.error(`[${APP_LOG_PREFIX}] Production environment misconfiguration:\n`, errors.join('\n'))
  }

  if (isApiUseRelative() && isProductionBuild()) {
    console.info(`[${APP_LOG_PREFIX}] Production using same-origin /api (reverse proxy expected).`)
  }
}
